export namespace EcommerceSectionNamespace {
  export enum EEcommerceEventAction {
    WISH_CARD_SELECTION = 'WishCardSelection',
    WISH_CARD_DESELECTION = 'WishCardDeselection',
    CHECKOUT_ENTRANCE = 'Checkout - entrance',
    ORDER_AS_LAST_TIME_EDIT = 'Checkout - repeat delivery options - edit',
    ORDER_AS_LAST_TIME_CONTINUE = 'Checkout - repeat delivery options',
  }

  export enum EEcommercePageType {
    CART = 'Cart',
    UPSELLING = 'Order - Step 9',
    ORDER_AS_LAST_TIME = 'checkout_repeated',
  }

  export enum EEcommerceStepName {
    CART = 'step-0-cart',
    UPSELLING = '	step-9-upsel',
  }

  export enum EEcommerceStepNumber {
    CART = '0',
    UPSELLING = '9',
  }

  export enum EEcommerceCartActions {
    ADD = 'add',
    REMOVE = 'remove',
  }

  export enum EEcommerceList {
    UPSELLING = 'upselling',
  }

  export enum EEcommerceEventCategory {
    CART = 'Cart',
    TYP = 'ThankYou',
  }

  export enum EKind {
    OTHER = 'Other',
  }

  export enum EEcommercePaymentType {
    PAYPAL = 'PayPal',
  }

  export enum EEcommercePageViewPath {
    ORDER_AS_LAST_TIME = '/overlay_repeat_checkout/',
    CART = '/cart/',
    UPSELLING = '/upselling/',
    THANK_YOU = '/thankyou/',
    DELIVERY_AND_PAYMENT = '/delivery-and-payment/',
    GLOBAL_PAYMENT_REDIRECT_PAGE = '/payment/globalPayments/redirect',
    ADYEN_REDIRECT_PAGE = '/payment/adyen/redirect',
    GLOBAL_PAYMENT_REPAY = '/payment/globalPayments/repay',
    PRZELEWY_REPAY = '/payment/przelewy/repay',
    GOPAY_REDIRECT_PAGE = '/payment/gopay/redirect',
    PRZELEWY_REDIRECT_PAGE = '/payment/przelewy/redirect',
  }

  export enum EEcommercePageViewTitle {
    ORDER_AS_LAST_TIME = 'Repeated checkout',
    CART = 'Shopping Cart',
    UPSELLING = 'Offer Discount',
    FAILED_PAYMENT = 'Failed payment',
    FAILED_PAYMENT_TO_RETRY = 'Failed payment try again',
    PAID_ORDER = 'Paid order',
    THANK_YOU = 'Thank you for order',
    DELIVERY_AND_PAYMENT = 'Delivery and payment',
    PAYMENT_REPAY_LINK = 'Payment repay link',
  }

  export enum EEcommerceEvent {
    VIEW_CART = 'view_cart',
    VIEW_ITEM = 'view_item',
    PAGE_VIEW = 'page_view',
    COUPON_INSERTED = 'coupon_inserted',
    COUPON_REMOVED = 'coupon_removed',
    REMOVE_FROM_CART = 'remove_from_cart',
    BEGIN_CHECKOUT = 'begin_checkout',
    ADD_TO_CART = 'add_to_cart',
    CHECKOUT_GO_TO_PURCHASE = 'checkout_go_to_purchase',
    CHECKOUT_EDIT_REPEATED_PURCHASE = 'checkout_edit_repeated_purchase',
    GIFT_PACKAGING_GIFT_CARD_ADD = 'checkout_gift_add_wishcard',
    GIFT_PACKAGING_GIFT_CARD_REMOVE = 'checkout_gift_remove_wishcard',
    ADD_TO_CART_EDIT = 'add_to_cart_edit',
    ELEMENT_CLICK = 'element_click',
    CHECKOUT_PAY = 'checkout_pay',
    PURCHASE_FAILED = 'purchase_failed',
    PURCHASE = 'purchase',
    CLOUD_RETAIL = 'cloud_retail',
    SHOPPING_CART_VIEW = 'shopping-cart-page-view',
    PURCHASE_COMPLETE = 'purchase-complete',
    ADD_TO_CART_DELLOITE = 'add-to-cart',
    CHECKOUT_DELIVERY_SELECTION_OPEN = 'checkout_delivery_selection_open',
    CHECKOUT_DELIVERY_SELECTION_SELECT = 'checkout_delivery_selection_select',
    CHECKOUT_DELIVERY_SELECTION_PROVIDER = 'checkout_delivery_selection_provider',
    CHECKOUT_DELIVERY_SELECTION_MAP = 'checkout_delivery_selection_map',
    CHECKOUT_DELIVERY_SELECTION_POINT = 'checkout_delivery_selection_point',
    CHECKOUT_DELIVERY_SELECTION_SEARCH = 'checkout_delivery_selection_search',
    CHECKOUT_DELIVERY_SELECTION_POINT_INFO = 'checkout_delivery_selection_point_info',
    CHECKOUT_DELIVERY_SELECTION_CLOSE = 'checkout_delivery_selection_close',
    CHECKOUT_CLOSE_REPEATED_PURCHASE = 'checkout_close_repeated_purchase',
    CHECKOUT_WT_PAY = 'checkout_wt_pay',
    CHECKOUT_WT_PAY_FAIL = 'checkout_wt_pay_fail',
    PAYMENT_DIALOG_DISPLAYED = 'payment_dialog_displayed',
    CHECKOUT_PAYMENT_DIALOG_FAIL = 'checkout_payment_dialog_fail',
    SELECT_ITEM = 'select_item',
    ERROR_DL = 'error_dl',
    SUBPAGE_VIEW = 'subpage_view',
    SELECT_ITEM_FAILED = 'select_item_failed',
    STATUS_SET = 'status_set',
    SUBPAGE_CLOSE = 'subpage_close',
    ADD_TO_CART_FAILED = 'add_to_cart_failed',
    FORM_SUBMIT_FAILED = 'form_submit_failed',
  }

  export enum EEcommerceInteraction {
    BUTTON = 'button',
    BUTTON_CHECKOUT = 'button_checkout',
    BUTTON_CHECKOUT_DOWN_SCROLL = 'button_checkout_down_scroll',
    BUTTON_CHECKOUT_STICKY = 'button_checkout_sticky',
    BUTTON_PAYPAL = 'button_paypal',
    CLICK_OUT = 'click_out',
    CLICK_GROUP = 'click_group',
    ZOOM_IN = 'zoom_in',
    ZOOM_OUT = 'zoom_out',
    BUTTON_CHANGE = 'button_change',
    CLICK = 'click',
    ICON_ADD = 'icon_add',
    ICON_REMOVE = 'icon_remove',
    CLICK_MAP = 'click_map',
    CLICK_LIST = 'click_list',
    BUTTON_X = 'button_x',
    MOVE = 'move',
    KEY = 'key',
    NOTHING = 'nothing',
    OPEN = 'open',
    TEXT_SECTION = 'text_section',
    RADIO_BUTTON = 'radio_button',
    CLICK_LINK = 'click_link',
    PICTOGRAM_COPY = 'pictogram_copy',
    LINK_CHECKOUT_STICKY = 'link_checkout_sticky',
  }

  export enum EEcommerceStatus {
    OK = 'ok',
    INACTIVE = 'inactive',
  }

  export enum EEcommerceCouponAction {
    COUPON_INSERT_OK = 'coupon_insert_ok',
    COUPON_INSERT_FAILED = 'coupon_insert_failed',
    COUPON_REMOVED = 'coupon_removed',
  }

  export enum EEcommerceCouponType {
    COUPON = 'coupon',
  }

  export enum EEcommercePageViewType {
    CART = 'cart',
    ORDER_AS_LAST_TIME = 'checkout_repeated',
    UPSELLING = 'checkout_upselling',
    OTHER = 'checkout_other',
    DELIVERY_AND_PAYMENT = 'checkout_delivery_and_payment',
    THANK_YOU = 'purchase',
  }

  export enum EEcommercePageViewUnifiedName {
    ORDER_AS_LAST_TIME = 'overlay_repeat_checkout',
    UPSELLING = 'checkout_upselling',
    FAILED_PAYMENT = 'order-failed-payment',
    FAILED_PAYMENT_TO_RETRY = 'order-failed-payment-re',
    PAID_ORDER = 'order-paid',
    DELIVERY_AND_PAYMENT = 'checkout_delivery_and_payment',
    THANK_YOU = 'order-confirmation',
    ORDER_REPAY = 'order-repay',
    SERVICE_INFO_MODAL = 'service-info-modal',
  }

  export enum EECommercePlatform {
    DESKTOP = 'Desktop',
    MOBILE = 'Mobile',
  }

  export enum EEcommerceExponeaEventName {
    CART_UPDATE = 'cart/update',
  }

  export enum EEcommerceAction {
    OPEN_GIFTS = 'open_gifts',
    CLOSE_GIFTS = 'close_gifts',
    CLICK_ON_PAYMENT_DIALOG_BACK = 'click_on_payment_dialog_back',
    CLOSE_DELIVERY_SECTION = 'close_delivery_section',
    OPEN_DELIVERY_SECTION = 'open_delivery_section',
    SELECT_DELIVERY_PROVIDER = 'select_delivery_provider ',
    COPY_COUPON_CODE = 'copy_coupon_code',
    FORM_SUBMIT_FAILED = 'form_submit_failed',
  }

  export enum EEcommerceMode {
    CLOSE = 'close',
    OPEN = 'open',
  }

  export enum EEcommerceName {
    GIFTS = 'gifts',
    PAYMENT_DIALOG_BACK = 'payment_dialog_back',
    NOTINO = 'notino',
    UPSELLING_PDP = 'upselling_pdp',
    PD_IMAGE = 'pd_image',
    FREE_DELIVERY = 'free_delivery',
    FREE_DELIVERY_CROSS_SELL = 'free_delivery_cross_sell',
    INSURANCE_INFO = 'insurance_info',
    GIFT_PACKAGING_INFO = 'gift_package_info',
    BACK_TO_SHOPPING = 'back_to_shopping',
    BACK_TO_CART = 'back_to_cart',
    BACK_TO_UPSELLING = 'back_to_upselling',
    BACK_TO_LOG_IN = 'back_to_log_in',
    FORWARD_TO_LOG_IN = 'forward_to_log_in',
    FORWARD_TO_DELIVERY_AND_PAYMENT = 'forward_to_delivery_and_payment',
    FORWARD_TO_SUMMARY = 'forward_to_summary',
    LINK_TO_COUPON = 'link_to_coupon',
  }

  export enum EEcommerceType {
    GIFTS = 'gifts',
    DELIVERY = 'delivery',
    PRODUCT_MINI = 'product_mini',
    CHECKOUT = 'checkout',
    CART = 'cart',
    CHECKOUT_SERVICE = 'checkout_service',
    CHECKOUT_CART = 'checkout_cart',
    CHECKOUT_UPSELLING = 'checkout_upselling',
    CHECKOUT_DELIVERY_AND_PAYMENT = 'checkout_delivery_and_payment',
  }

  export enum EEcommercePaymentType {
    CARD = 'card',
  }

  export enum EEcommercePaymentProvider {
    ADYEN = 'adyen',
    PAYPAL = 'paypal',
    PRZELEWY24 = 'przelewy24',
  }
  export enum EEcommerceOaltStepName {
    FIRST_STEP = 'oalt_step_overview',
    SECOND_STEP = 'oalt_step_provider',
    THIRD_STEP = 'oalt_step_3ds',
    ERROR_STEP = 'oalt_step_error',
  }
  export enum CartType {
    cart = 'Cart',
    clickAndCollect = 'ClickAndCollect',
    giftcard = 'GiftCard',
    unknown = 'NULL',
  }

  export enum EUpsellingPdpTabName {
    DESCRIPTION = 'Description PD',
    COMPOSITION = 'Composition PD',
    OTHER = 'Other PD',
  }

  export enum EUpsellingPdpTabMode {
    OPEN = 'open',
    CLOSE = 'close',
  }

  export enum EUpsellingPdpImageInteraction {
    BUTTON = 'button',
    MOBILE_TAP = 'mobile_tap',
    SWIPE = 'swipe',
  }
}
